import React from "react";
import data from "../../json/ProjectManagement/services.json";
import { ReactComponent as Icon1 } from "../../../src/Icons/service1.svg";
import { ReactComponent as Icon2 } from "../../../src/Icons/service2.svg";
import { ReactComponent as Icon3 } from "../../../src/Icons/service3.svg";
import { ReactComponent as Icon4 } from "../../../src/Icons/service4.svg";

const Services = () => {
  const icons = [Icon1, Icon2, Icon3, Icon4];
  return (
    <div className="w-full flex justify-center">
      <div className="2xl:container w-full p-4 md:px-10 lg:px-20 flex flex-col lg:flex-row ">
        <section className="w-full md:w-9/12 lg:w-2/5 mt-0 lg:mt-[72px]">
          <div className="flex flex-col gap-4">
            <h1 className="text-28 lg:text-40">{data.Title}</h1>
            <p className="text-14 md:text-18 text-approachblk">{data.para}</p>
          </div>
        </section>
        <section className="w-full lg:w-3/5 flex mt-10 lg:mt-0">
          <div className="w-full grid grid-cols-1 md:grid-cols-2 md:flex-row md:flex-wrap gap-3 justify-center lg:justify-end lg:ml-5 relative">
            {data.services.map((ele, i) => {
              let Icon = icons[i];
              return (
                <div className=" p-6 w-full md:w-[43.685vw] lg:w-[24.744vw] lg:max-w-[340px] h-fit rounded-[24px] border-[1px] border-[services] group  serviceparent serviceouter">
                  <div className="flex items-center flex-col gap-4 ">
                    <Icon className="serviceicon servicechild" />
                    <div className="text-center space-y-3 servicedetails">
                      <h1 className="text-18 md:text-20 text-normal font-medium servicechild">
                        {ele.heading}
                      </h1>
                      <p className="text-14 md:text-base text-approachblk servicechild">
                        {ele.desc}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Services;
